import script from "./questionTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./questionTwo.vue?vue&type=script&setup=true&lang=js"

import "./questionTwo.vue?vue&type=style&index=0&id=6a9863e8&scoped=true&lang=scss"

import exportComponent from "D:\\a-mydemo\\houlang\\gs-demo\\keymemo-demo\\keymemory-pc-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a9863e8"]])

export default __exports__